import { graphql } from "../gql";

export const getProviderClaimQueryDoc = graphql(`
  query providerClaim($id: UUID!) {
    claim(id: $id) {
      __typename
      id
      icn
      itemizedBillLines {
        ...ProviderItemizedBillLineFragment
      }
    }
  }
`);
